<template>
  <footer id="footer">
    <div class="box flex flex-space web-footer">
      <div class="footer-left flex flex-space flex-warp">
        <div><b>产品服务</b></div>
        <div><b>咨讯动态</b></div>
        <div><b>关于合能</b></div>

        <div
          v-for="(item, index) in links"
          :key="'footNav' + index"
          @click="footClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="footer-right flex flex-space">
        <div id="address">
          <b>联系我们</b>
          <p class="phone-num"><i class="el-icon-phone"></i>028-85094050</p>
          <p>公司总部：成都天府大道中段666号希顿国际广场B座23楼、24楼</p>
          <a href="https://beian.miit.gov.cn/" target="_blank">
            <p>Copyright ©2021 互联网ICP备案：蜀ICP备15005277号-3</p>
          </a>
          <div class="record-row">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002004743"
            >
              <p>
                <img
                  src="../assets/img/chuangongan.png"
                  style="float:left;padding-right: 5px"
                />
                川公网安备 51019002004743号
              </p>
            </a>
            <a
              href="https://xyt.xcc.cn/getpcInfo?sn=1763156082919690240&language=CN&certType=8&url=*.cdhncy.cn"
              target="_blank"
              class="cert-link"
            >
              <embed
                :src="require('../assets/img/cdhncy.cn.svg')"
                width="103"
                height="38"
                type="image/svg+xml"
                pluginspage="//www.adobe.com/svg/viewer/install/"
              />
            </a>
          </div>
        </div>
        <div id="code">
          <b>官方微信</b><br />
          <img class="mt20" src="../assets/img/codeimg.png" alt="" />
        </div>
      </div>
    </div>
    <div class="box flex flex-content flex-column phone-footer">
      <div class="code">
        <img class="mt10" src="../assets/img/codeimg.png" alt="" />
      </div>
      <div class="address">
        联系我们
        <span><i class="el-icon-phone"></i>028-85094050</span>
        <p>公司总部：成都天府大道中段666号希顿国际广场B座23楼、24楼</p>
        <a href="https://beian.miit.gov.cn/" target="_blank">
          <p>Copyright ©2021 互联网ICP备案：蜀ICP备15005277号</p>
        </a>
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002004743"
        >
          <p>
            <img src="../assets/img/chuangongan.png" />
            川公网安备 51019002004743号
          </p>
        </a>
      </div>
      <div>
        <a href="https://xyt.xcc.cn/getpcInfo?sn=1763156082919690240&language=CN&certType=8&url=*.cdhncy.cn" 
        target="_blank" 
        style="position: relative;
        display: inline-block; 
        height: 38px;">
        <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
          <embed :src="require('../assets/img/cdhncy.cn.svg')"
          width="103"
          height="38"
          type="image/svg+xml"
          pluginspage="//www.adobe.com/svg/viewer/install/" />
        </a>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterCom",
  data() {
    return {
      links: [
        { name: "产品中心", index: 1, path: "/product" },
        { name: "新闻动态", index: 4, path: "/news" },
        { name: "公司介绍", index: 6, path: "/about" },
        { name: "典型案例", index: 3, path: "/typicalCases" },
        { name: "人才招聘", index: 7, path: "/joins" },
        { name: "服务支持", index: 5, path: "/support" }
      ]
    };
  },
  methods: {
    footClick(item) {
      window.scrollTo(0, 0);

      if (item.newPage) {
        window.open(item.path);
      } else {
        this.$store.commit("changeNav", item.index);
        sessionStorage.setItem("id", "");
        this.$router.push({
          path: item.path
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common";

#footer {
  width: 100%;
  height: 300px;
  background-color: rgba(35, 34, 34, 1);
  color: #ffffff;
  padding: 100px 50px;
  box-sizing: border-box;

  .footer-left,
  .footer-right {
    width: 50%;
  }

  b {
    font-size: 18px;
    color: #ffffff;
  }

  .footer-left div {
    width: 33%;
    font-size: 14px;
    color: #abaeb2;
    cursor: pointer;

    a {
      color: #abaeb2;
    }
  }

  .footer-left div:hover,
  .footer-left div:hover a {
    color: #f0f0f0;
  }

  .footer-right .phone-num {
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    margin: 18px 0 10px 0;

    i {
      margin-right: 10px;
    }
  }

  .footer-right p {
    color: #abaeb2;
    font-size: 12px;
  }

  .footer-right span {
    line-height: 90px;
  }

  .record-row {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }

  .record-row .cert-link {
    display: inline-flex;
    align-items: center;
    margin-left: 12px;
    height: 38px;
  }
}

.phone-footer {
  width: 100%;
  display: none;

  .code {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .address {
    width: 100%;
  }
}

@media screen and (max-width: 1160px) {
  .navbar {
    display: none;
  }

  .web-footer {
    display: none;
  }

  .phone-footer {
    display: block;

    .address {
      text-align: center;
      font-size: 12px;
      margin-top: 20px;
    }
  }
}

@media screen and (max-width: 600px) {
  #footer {
    padding: 50px 10px 50px 10px;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterCom.vue